import { RefObject } from "react";

export const isDescendant = (el: any, parentEl: any) => {
    let isChild = false;

    if (typeof el.className === 'string' && el === parentEl) {
        isChild = true;
    }

    while ((el = el.parentNode)) {
        if (typeof el.className === 'string' && el === parentEl) {
            isChild = true;
        }
    }

    return isChild;
};

export const getTextWidth = (text: any, font: any) => {
    // re-use canvas object for better performance
    var canvas =
        (getTextWidth as any).canvas ||
        ((getTextWidth as any).canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
};